import styled from 'styled-components';

export const WorkloadsHeader = styled.div`
  justify-content: space-between;
  align-items: center;
  padding: 20px 5px;
  display: flex;
`;

export const WorkloadsHeaderTitle = styled.span`
  color: var(--DarkGray);
  line-height: 23.68px;
  font-weight: 600;
  font-size: 17px;
`;

export const WorkloadsHeaderLeft = styled.div`
  justify-content: space-between;
  padding: 0 10px;
  display: flex;

  & > div:first-of-type {
    margin-right: 20px;
  }
`;

export const WorkloadsBody = styled.div`
  display: flex;
  justify-content: center;

  & > table:first-of-type {
    margin-right: 20px;
  }
`;
